/* global angular, TweenMax, $, Power2 */
angular.module('ua5App')
    .directive('logoAnimation', ['$rootScope', function($rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'components/logo_animation/logo_animation.html',
            link: function($scope, $element, $attrs) {
                var $logo = $element.find('.logo-animation__container');

                function expandLogo() {
                    var TRANSITION_CSS_TIME = 800;
                    $scope.animate = true;
                    $scope.$apply();

                    setTimeout(function() {
                        $rootScope.hasRevealedLogo = true;
                        $rootScope.$broadcast('logoAnimationComplete');
                    }, TRANSITION_CSS_TIME);
                }

                function showLogo(onComplete) {
                    $logo.addClass('logo-animation__show');
                    setTimeout(onComplete, 2000);
                }

                $scope.$on('expandLogo', function() {
                    expandLogo();
                });

                $scope.$on('finishLogoAnimation', function() {
                    showLogo(function() {
                        $rootScope.$broadcast('finishLogoAnimationComplete');
                    });
                });

                $rootScope.$on('pingLogo', function() {
                    resetLetters();
                    flickLetter();
                });

                $rootScope.$on('unpingLogo', function() {
                    resetLetters();
                });

                function getRandomInt(min, max) {
                    return Math.floor(Math.random() * (max - min + 1)) + min;
                }

                function flickLetter() {
                    var $letters = $element.find('.logo-animation__container');
                    var numElements = $letters.length;
                    var randomNum = Math.floor(Math.random() * numElements);
                    //Select your random element
                    var $randomLetter = $($letters[randomNum]);

                    $randomLetter.attr('data-shown', 'true');
                    TweenMax.set($randomLetter, {
                        y: -60,
                        alpha: 0
                    });
                    TweenMax.to($randomLetter, 0.60, {
                        y: 0, alpha: 1, ease: Power2.easeOut
                    });

                    setLetter($randomLetter, getRandomInt(1, 3));
                }

                function setLetter($letter, num) {
                    var id = $letter.attr('data-letter-id');
                    var path = 'components/logo_animation/assets/' + id + '-' + num + '.png';
                    $letter.find('img').attr('src', path);
                }

                function resetLetters() {
                    var $letters = $element.find('.logo-animation__container');

                    $letters.each(function() {
                        var $this = $(this);
                        var attr = $(this).attr('data-shown');

                        if (typeof attr !== typeof undefined && attr !== false) {
                            $this.removeAttr('data-shown');
                            TweenMax.to($this, 0.75, {
                                y: -100, alpha: 0,
                                onComplete: function() {
                                    setLetter($this, 4);
                                    TweenMax.set($this, {
                                        y: 0, alpha: 1
                                    });

                                    TweenMax.set($this.find('img'), {
                                        alpha: 0
                                    });

                                    TweenMax.to($this.find('img'), 0.60, {
                                        alpha: 1
                                    });
                                }
                            });
                        }

                    });
                }
            }
        };
    }])
;
